<template>
   <div>
<!--  -->
        <div class="divCenter" @click="to_api">
			
        </div>
    </div>
</template>
<!-- mounted() {
    this.adid = this.$route.query.adid
    this.creativeid = this.$route.query.creativeid
    this.creativetype = this.$route.query.creativetype
    this.clickid = this.$route.query.clickid
    this.code = this.$route.query.code
    if (this.$route.query.adid == undefined) {
        this.adid = null
    }
    if (this.$route.query.creativeid == undefined) {
       this.creativeid = null
    }
    if (this.$route.query.creativetype == undefined) {
        this.creativetype = null
    }
    if (this.$route.query.clickid == undefined) {
        this.clickid = null
    }
}, -->
<script>
import axios from "axios"
// import { testdata } from '@/api/userApi.js'
export default {
    data() {
        return {
            adid: "",
            creativeid: "",
            creativetype: "",
            clickid: ""
        }
    },
    mounted() {
        this.adid = this.$route.query.adid
        this.creativeid = this.$route.query.creativeid
        this.creativetype = this.$route.query.creativetype
        this.clickid = this.$route.query.clickid
		
    },
    methods: {
        to_api() {
        //     let data = {
        //         adid: this.adid,
        //         creativeid: this.creativeid,
        //         creativetype: this.creativetype,
        //         clickid: this.clickid,
        //         code: this.$route.query.code,

        //     }
            // this.$http.post("/address", data).then(res => {
            //     console.log(res);
            // });
            // axios({
            //     method: "GET",
            //     url: "https://dy01.txcfgl.net:10081/v1/applet/getUrl?adid=" + data.adid + "&creativeid=" + data.creativeid + "&creativetype=" + data.creativetype + "&clickid=" + data.clickid + "&code=" + data.code,
            //     // url: "http://172.16.2.154:8080/v1/applet/getUrl?adid=" + data.adid + "&creativeid=" + data.creativeid + "&creativetype=" + data.creativetype + "&clickid=" + data.clickid + "&code=" + data.code,
            // }).then(res => {
			// axios({
			//     method: "GET",
			//     url: "https://dy01.txcfgl.net:10081/v1/clutter/save?"+"clickid=" + data.clickid + "&livecode=ca_62"
			//     // url: "http://172.16.2.154:8080/v1/applet/getUrl?adid=" + data.adid + "&creativeid=" + data.creativeid + "&creativetype=" + data.creativetype + "&clickid=" + data.clickid + "&code=" + data.code,
			// }).then(ress => {
			  //   setTimeout(() => {
					// if(data.clickid!=undefined){
					// 	var length=data.clickid.slice(46,76);
					// 	window.location.href ="https://work.weixin.qq.com/ca/cawcdeba52bd81c332?customer_channel=ca_62_"+length
					// }else{
						
						axios({method: "GET",url:'https://dy01.txcfgl.net:10081/v1/clutter/resourcesCheck?livecode=ca_111'}).then(res=>{
							if(res.data.data==1){
								window.location.href ="https://work.weixin.qq.com/ca/cawcdebd28bf2a6ad0?customer_channel=ca_111"
							}else{
								window.location.href ="https://www.txcfgdd666.com/kongbai"
							}
						});
						
					// }
			  //   }, 300);
			// })
            // })
        },
        // test(){
        // 	let param={
        //         adid: this.$route.query.adid,
        //         creativeid: this.$route.query.creativeid,
        //         creativetype: this.$route.query.creativetype,
        //         clickid: this.$route.query.clickid,
        //         code: this.$route.query.code,
        // 	}
        // 	testdata(param).then(res=>{
        //         console.log(res);
        //         // window.location.href = res.data.url

        // 	})
        // }
    },

}
</script>

<style>
/* .h1 {
    width: 100%;
    height: 7.8rem;
    background: url(../assets/imgs/tck/落地页-题材库.jpg);
    background-size: 100% 100%;
} */

.imgs {
    padding-left: .5rem;
    padding-top: 7.83rem;
}

img {
    width: 6.5rem;
    height: 1.30rem;
}
.divCenter{
	background: url(../assets/imgs/dy/tckNew.jpg);
	background-size: 100% 100%;
	display: grid;
	place-items: center;
	height: 15.0rem;
	border:1px solid black
}
</style>